import React, { useEffect, useRef } from 'react'
import { X } from 'lucide-react'
import './IceModal.css'
import Tooltip from './Tooltip'

type IceModalProps = {
  isOpen: boolean
  onClose: () => void
  title?: string
  children?: React.ReactNode
  // Mode confirmation rapide (remplace IonAlert)
  message?: string
  buttons?: { text: string, color?: 'primary' | 'danger' | 'muted', handler: () => void }[]
  // Taille
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

let IceModal: React.FC<IceModalProps> = ({ isOpen, onClose, title, children, message, buttons, size = 'md' }) => {
  let backdropRef = useRef<HTMLDivElement>(null)

  // Fermer avec Escape
  useEffect(() => {
    if (!isOpen) return
    let handleEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="ice-modal-backdrop"
      ref={backdropRef}
      onClick={(e) => { if (e.target === backdropRef.current) onClose() }}
    >
      <div className={`ice-modal ice-modal-${size}`}>
        {/* Header */}
        {title && (
          <div className="ice-modal-header">
            <h3>{title}</h3>
            <Tooltip label="Fermer" position="left"><button className="ice-modal-close" onClick={onClose}><X size={18} /></button></Tooltip>
          </div>
        )}

        {/* Body */}
        <div className="ice-modal-body">
          {message && <p className="ice-modal-message">{message}</p>}
          {children}
        </div>

        {/* Footer avec boutons (mode confirmation) */}
        {buttons && buttons.length > 0 && (
          <div className="ice-modal-footer">
            <button className="ice-modal-btn ice-modal-btn-muted" onClick={onClose}>Annuler</button>
            {buttons.map((btn, i) => (
              <button
                key={i}
                className={`ice-modal-btn ice-modal-btn-${btn.color || 'primary'}`}
                onClick={() => { btn.handler(); onClose() }}
              >
                {btn.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default IceModal
